import { render, staticRenderFns } from "./PageToken.vue?vue&type=template&id=ac0fdbf4&scoped=true"
import script from "./PageToken.vue?vue&type=script&lang=js"
export * from "./PageToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0fdbf4",
  null
  
)

export default component.exports